import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import { VideoPlayerManager } from 'utils/video-player-manager'
import {getRegionList, getEncoderList, getDepartmentList, getPersonList} from '@/api/get-data.js'

export default {
  name: 'ShowStreamNodeModal',
  data () {
    return {
      activeTabName: '0',
      playProtocol: this.$globalConfig.playProtocol, // 播放协议，0-rtmp,1-hls,2-http-flv,3-ws-flv
      playerManager: null,
      player: null,
      gisMarkerOwnerPersonPhone: '',
      gisMarkerMaintenancePersonPhone: ''
    }
  },
  props: {
    modalOpen: {
      type: Boolean,
      default: false
    },
    gisMarker: {
      type: Object,
      default: {}
    }
  },
  mixins: [
    convertorMixin,
    idNameMixin
  ],
  created() {
    // 创建播放器管理器
    this.playerManager = new VideoPlayerManager()
    this.player = this.playerManager.findFirstInactiveVideoPlayer()
  },
  mounted () {
    // 获取监控设备列表
    getEncoderList(() => {
      // 获取部门列表
      getDepartmentList(() => {
        // 获人员列表
        getPersonList(() => {
          // 获取区域列表
          getRegionList(this.$globalConfig.regionGettingFilterMode, null)
        })
      })
    })
  },
  methods: {
    //
    handleToggleVideo () {
      if (!this.player.active) {
        this.playerManager.openVideoPlayer(this.gisMarker.id, this.gisMarker.name, this.gisMarker.streamOpenMode,
          false, this.$store.getters.userToken, this.playProtocol, this.gisMarker.streamServerIp, this.gisMarker.streamServerPort3)
      } else {
        this.playerManager.closeVideoPlayer(this.gisMarker.id)
      }
    },
    // 取消提交记录
    handleModalCancel () {
      this.playerManager.closeAll()
      this.$emit('cancel', false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/common/showStreamNodeModal/ShowStreamNodeModal.js